import React, { useEffect, useState } from "react";
import { Player } from "video-react";
import { iconData } from "../../../../iconData";
import PdfViewer from "../../../PdfViewer/PdfViewer";
import { IP } from "../../../../internalServer";
import ZoomableImage from "./ZoomableImage";

export default function CheckBoxType({
  question,
  questionNo,
  setQuestionsAnswer,
  questionsAnswer,
  pendingData,
  saveAnswersToLocalStorage
}) {
  const [mideaviewer, setMideaviewer] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  const [checkboxes, setCheckboxes] = useState();
  const [isClicked, setIsClicked] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
  });
  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
    });
  };
  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };
  const handlePdfClick = (attachment) => {
    setTimeout(() => {
      setResponseAttach(attachment);
      setMideaviewer(true)
    }, 100)
  };

  useEffect(() => {
    !questionsAnswer.find((i) => i.question_id === question?.id) &&
      setQuestionsAnswer((prev) => [
        ...prev,
        {
          question_id: question?.id,
          answer: {
            key: null,
            explanation: null,
          },
        },
      ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // useEffect(() => {
  //   console.log("question from on pending : ", question)
  //   console.log("questionNo from on pending : ", questionNo)
  //   console.log("questionsAnswer from on review : ", questionsAnswer)
  // }, [])

  const poster =
    "https://images.unsplash.com/photo-1431499012454-31a9601150c9?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80";

  const handleCheckboxChange = (option) => {
    // checkboxes === option?.key
    //   ? setCheckboxes(null)
    //   : setCheckboxes(option?.key);
    // checkboxes === option?.key
    //   ? setQuestionsAnswer((prev) =>
    //       prev.filter((i) => i.question_id !== question?.id)
    //     )
    //   : setQuestionsAnswer((prev) => {
    //       const prevData = prev.filter((i) => i.question_id !== question?.id);
    //       return [
    //         ...prevData,
    //         {
    //           question_id: question?.id,
    //           answer: {
    //             key: option?.key,
    //             explanation: option?.value,
    //           },
    //         },
    //       ];
    //     });
    setQuestionsAnswer((prev) => {
      let updatedData = prev.map((item) => {
        if (item.question_id === question?.id) {
          if (item.answer.key === option?.key) {
            return {
              ...item,
              answer: {
                key: "",
                explanation: "",
              },
            };
          } else {
            return {
              ...item,
              answer: {
                key: option?.key,
                explanation: option?.value,
              },
            };
          }
        }
        return item;
      });

      if (!updatedData.some((item) => item.question_id === question?.id)) {
        updatedData.push({
          question_id: question?.id,
          answer: {
            key: option?.key,
            explanation: option?.value,
          },
        });
      }
      const validQuestions = updatedData.filter(
        (q) =>
          q.answer &&
          q.answer.key?.trim() !== "" &&
          q.answer.explanation?.trim() !== ""
      );
      saveAnswersToLocalStorage(validQuestions, pendingData?.id)
      return updatedData;
    });
  };

  const normalizeFile = (file) => {
    if (!file) return "";

    // already string
    if (typeof file === "string") return file;

    // object cases
    if (typeof file === "object") {
      return (
        file.url ||
        file.file_path ||
        file.path ||
        file.name ||
        ""
      );
    }

    return "";
  };


  const IMAGE_EXTS = ["jpg", "jpeg", "png"];

  const getFileExt = (file) => {
    const f = normalizeFile(file);
    return f ? f.split(".").pop().toLowerCase() : "";
  };

  const getFileName = (file) => {
    const f = normalizeFile(file);
    return f ? f.split("/").pop().replace(/^[^_]*_/, "") : "";
  };


  const getShortName = (name, limit = 15) =>
    name.length > limit ? name.slice(0, limit) + "..." : name;

  const truncate = (text, max = 20) =>
    text?.length > max ? text.slice(0, max) + "..." : text;

  return (
    <>
      <div className="containerBelowQuestion" style={{ height: "280px" }}>
        <div className="d-flex justify-content-between">
          <div className="Question">
            Q{questionNo}. {question?.title?.split("\n").map((line, index) => (
              <React.Fragment key={index}>
                {index !== 0 && <br />}
                <span style={index !== 0 ? { marginLeft: "30px", display: "inline-block" } : {}}>
                  {line}
                </span>
              </React.Fragment>
            ))}
          </div>
          {/* <div className="marksQue">{question?.correct_score} Marks</div> */}
        </div>
        {question?.attachments?.length > 0 &&
          question.attachments.map((attachment, index) => {
            console.log("attachment????", attachment);

            const ext = getFileExt(attachment);
            const fileName = getFileName(attachment);
            const isImage = IMAGE_EXTS.includes(ext);

            return (
              <div key={index}>
                {isImage ? (
                  <img
                    className="mt-3 imageWidthAndHeight"
                    style={{ cursor: "pointer" }}
                    src={
                      typeof attachment === "string"
                        ? IP + attachment.replace(/^\./, "")
                        : IP + (attachment?.url || "").replace(/^\./, "")
                    }
                    alt="Attachment"
                    onClick={() => !isError && handleClick(attachment)}
                  />
                ) : (
                  <div
                    className="mt-2"
                    onClick={() =>
                      handlePdfClick(attachment)
                    }
                  >
                    <div className="d-flex pdfContainer gap-2 p-2">
                      <div className="d-flex align-items-center">
                        <img
                          className="extention_icon"
                          src={
                            iconData?.find((i) => i.extension === ext)?.icon
                          }
                          alt=""
                        />
                      </div>

                      <div className="w-100">
                        <div className="pdfName" title={fileName}>
                          {getShortName(fileName)}
                        </div>
                        <div className="pdfFileSize">12 KB</div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}

        <div className="mt-4 optionContainer ml-2">
          {question?.options?.length > 0 &&
            question?.options?.map((option, index) => {
              return (
                <>
                  <div key={option?.key} className="d-flex justify-content-between">
                    <div className="d-flex gap-2 ">
                      <div style={{ width: "50px" }}>
                        {
                          option?.key + ". "
                        }
                        <input
                          key={question?.id}
                          type="checkbox"
                          className="hwCheckbox ml-1"
                          checked={
                            // checkboxes === option?.key ||
                            questionsAnswer.find(
                              (i) => i?.question_id === question?.id
                            )?.answer?.key === option?.key
                          }
                          onChange={() => {
                            handleCheckboxChange(option)
                          }}
                        />
                      </div>
                      <div
                        className={` ${questionsAnswer.find(
                          (i) => i?.question_id === question?.id
                        )?.answer?.key === option?.key
                          ? "QueOptionsChecked"
                          : "QueOptions"
                          }`}
                      >
                        {option?.value}
                      </div>
                    </div>
                    {questionsAnswer.find((i) => i?.question_id === question?.id)
                      ?.answer?.key === option?.key && (
                        <div className="yourAnswer">Your answer</div>
                      )}
                  </div>
                  <div className="ml-6">
                    {/*  */}
                    {/* {option.attachment &&
                      (() => {
                        const ext = option.attachment.split(".").pop().toLowerCase();
                        const isImage = ["jpg", "jpeg", "png"].includes(ext);
                        return isImage ? (
                          <ZoomableImage src={option.attachment} />
                        ) : null;
                      })()} */}
                    {option.attachment && (() => {
                      const fileUrl =
                        typeof option.attachment === "string"
                          ? option.attachment
                          : option.attachment?.url;

                      if (!fileUrl) return null;

                      const fileType = fileUrl.split(".").pop().toLowerCase();
                      const isImage = ["jpg", "jpeg", "png"].includes(fileType);
                      const isVideo = ["mp4", "mov"].includes(fileType);
                      const isPdf = fileType === "pdf";

                      const fileIcon =
                        iconData?.find((i) => i.extension === fileType)?.icon ||
                        "/images/file_icon.png";

                      const fullUrl = fileUrl.startsWith("http")
                        ? fileUrl
                        : `${IP}${fileUrl}`;

                      return (
                        <div className="d-flex flex-row align-items-center me-3">
                          {/* ===== Preview ===== */}
                          {isImage ? (
                            <ZoomableImage src={option.attachment} />
                          ) : isVideo ? (
                            <video
                              src={fullUrl}
                              style={{
                                width: "60px",
                                height: "50px",
                                borderRadius: "6px",
                                marginBottom: "5px",
                              }}
                              controls
                            />
                          ) : isPdf ? (
                            <div
                              onClick={() => handlePdfClick(fileUrl)}
                              style={{
                                width: "100px",
                                height: "50px",
                                background: "#f5f5f5",
                                borderRadius: "6px",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin: "6px 0px"
                              }}
                            >
                              <img
                                src={fileIcon}
                                alt="pdf"
                                style={{ width: "24px", height: "24px" }}
                              />
                              <div className="hw_default_attach_name">
                                <span>
                                  {truncate(option.attachment?.replace(/^[^_]*_/, ""), 15)}
                                </span>
                              </div>
                            </div>
                          ) : (
                            <a
                              href={`https://docs.google.com/gview?url=${encodeURIComponent(
                                fullUrl
                              )}&embedded=true`}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ textDecoration: "none" }}
                            >
                              <div
                                style={{
                                  width: "100px",
                                  height: "50px",
                                  background: "#f5f5f5",
                                  borderRadius: "6px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <img
                                  src={fileIcon}
                                  alt="file"
                                  style={{ width: "24px", height: "24px" }}
                                />
                              </div>
                            </a>
                          )}
                        </div>
                      );
                    })()}
                  </div>
                </>
              )
            })}
        </div>
      </div>
      {mideaviewer && (
        <PdfViewer
          closeMideaviewer={setMideaviewer}
          attachment={responseAttach}
        />
      )}
      {console.log("responseAttach", responseAttach)};

      {isClicked &&
        (getFileExt(responseAttach).split(".").pop() === "mp4" || getFileExt(responseAttach).split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source src={
                  typeof responseAttach === "string"
                    ? IP + responseAttach.replace(/^\./, "")
                    : IP + (responseAttach?.url || "").replace(/^\./, "")
                } type="video/mp4" />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {
                !isError ? (
                  <>

                    <img
                      className="imgMain"
                      src={
                        typeof responseAttach === "string"
                          ? IP + responseAttach.replace(/^\./, "")
                          : IP + (responseAttach?.url || "").replace(/^\./, "")
                      }
                      alt="Full-size"
                      onError={(e) => {
                        setIsError(true)
                      }}
                    />
                    <div>
                      <img
                        className="crossIconImgQue"
                        onClick={handleClick}
                        src="/images/cross.png"
                        alt="Up Arrow"
                      />
                    </div>
                  </>
                ) : (
                  <div className="fullSizeImg" style={{ display: "flex", flexDirection: "column" }}>

                    <img
                      onClick={handleClick}
                      src="/images/cross.png"
                      alt="Up Arrow"
                      style={{ position: "absolute", top: "75px", right: "40%" }}
                    />
                    <img src="/images/no-photo1.png" alt="img" style={{ width: "25%" }} />
                    <p style={{ color: "red", fontSize: "20px", fontWeight: "500", marginRight: "35px" }}>Error!! failed to load the requested file!</p>
                  </div>
                )
              }
            </div>
          </div>
        ))}
    </>
  );
}
